/**
 * @desc 菜单信息
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.MenuIDParameter): Promise<BaseResponse<defs.ResultBean<defs.SysMenuEntityObject>>> {
  return fetch({
    url: config.API_HOST + '/auth/menu/getById',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
